import { render, staticRenderFns } from "./GCalculateSalaryProcessUploadPayroll.vue?vue&type=template&id=0b144fa8&"
import script from "./GCalculateSalaryProcessUploadPayroll.vue?vue&type=script&lang=js&"
export * from "./GCalculateSalaryProcessUploadPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports